// src/EnhancedComponents/auth.js
// Client-side session helpers. NOTE: the token is only checked in the
// browser — the PHP APIs do not validate it yet (see AdminLogin.php).
import { eraseCookie, getCookie, setCookie } from "./utils";

const TOKEN_COOKIE = "ADMIN_TOKEN";
export const SESSION_HOURS = 4;

export const isAuthenticated = () => !!getCookie(TOKEN_COOKIE);

export function startSession(token) {
  setCookie(TOKEN_COOKIE, token, SESSION_HOURS);
}

export function endSession() {
  eraseCookie(TOKEN_COOKIE);
}
